import { useEffect, useMemo } from "react";
import { CanvasTexture } from "three";

export function GradientBackground() {
  const texture = useMemo(() => {
    const size = 1024;

    const canvas = document.createElement("canvas");
    canvas.width = size;
    canvas.height = size;

    const ctx = canvas.getContext("2d")!;

    // Flat background
    ctx.fillStyle = "#7a8090";
    ctx.fillRect(0, 0, size, size);

    // Subtle floor band to help ground the model (very light, nearly transparent)
    const floorGradient = ctx.createLinearGradient(0, size, 0, size * 0.6);
    floorGradient.addColorStop(0, "rgba(0,0,0,0.38)");
    floorGradient.addColorStop(1, "rgba(0,0,0,0)");
    ctx.fillStyle = floorGradient;
    ctx.fillRect(0, size * 0.6, size, size * 0.4);

    const tex = new CanvasTexture(canvas);
    tex.needsUpdate = true;
    return tex;
  }, []);

  useEffect(() => {
    return () => texture.dispose();
  }, [texture]);

  return <primitive object={texture} attach="background" />;
}
